// Pure decision: what to do when /version.json reports a buildId that differs
// from the one compiled into this bundle. No DOM, no timers — unit tested.

export type UpdateAction = "none" | "reload" | "toast";

/** Idle this long (no pointer/key activity) and a pending update reloads silently. */
export const IDLE_RELOAD_MS = 10 * 60 * 1000;

export interface UpdateDecisionInput {
  /** `__APP_BUILD_ID__` of the running bundle. */
  currentBuildId: string | null | undefined;
  /** buildId from /version.json; null/undefined/"" when unknown (fetch failed). */
  serverBuildId: string | null | undefined;
  /** document.visibilityState === "hidden" */
  hidden: boolean;
  /** ms since the last user activity */
  idleMs: number;
  /** a form field was edited since the last navigation/submit */
  dirty: boolean;
  /** called from a client-side route change (a reload is cheap right now) */
  navigating: boolean;
  /** this session already reloaded once for serverBuildId and still runs an old build */
  alreadyReloadedFor: boolean;
}

export function decideUpdateAction(i: UpdateDecisionInput): UpdateAction {
  const server = (i.serverBuildId ?? "").trim();
  const current = (i.currentBuildId ?? "").trim();
  if (!server || !current || server === current) return "none";
  // We reloaded for this build already and the browser still handed us the
  // old bundle (heuristically cached index.html). Never loop: tell, don't act.
  if (i.alreadyReloadedFor) return "toast";
  // Unsaved input is never thrown away by an automatic reload.
  if (i.dirty) return "toast";
  if (i.navigating) return "reload";
  if (i.hidden || i.idleMs >= IDLE_RELOAD_MS) return "reload";
  return "toast";
}
